import { useQuery } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';
import { ApiConfig } from '@/config/api.config';
import { useAxiosAuth } from '@/hooks/useAxiosAuth';
import { SuperAdminOwnerDetailDto } from '@/features/superAdmin/features/data/types/superAdmin-data.types';

type LocationState = {
    owner?: SuperAdminOwnerDetailDto;
};

export const useSuperAdminOwnerDetailApi = (id?: string) => {
    const axiosInstance = useAxiosAuth();
    const location = useLocation();
    const locationState = location.state as LocationState | null;
    const stateOwner = locationState?.owner;
    const placeholderOwner = stateOwner?.id === id ? stateOwner : undefined;

    const { data, isLoading, error } = useQuery({
        queryKey: [ApiConfig.queries.superAdmin.data.owners.queryKeys.detail, id],
        enabled: Boolean(id),
        placeholderData: placeholderOwner,
        queryFn: async (): Promise<SuperAdminOwnerDetailDto> => {
            const response = await axiosInstance.get<SuperAdminOwnerDetailDto>(
                `${ApiConfig.queries.superAdmin.data.owners.endpoints.detail}/${id}`,
            );
            return response.data;
        },
    });

    return {
        owner: data,
        isLoading,
        error,
    };
};
